module.exports = __webpack_public_path__ + "img/mainhero.ba8fc8c8.png";